import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainer } from '@/modules/SinglePostDealerWeb/common.styles';
import { media } from '@/utils/mixin';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';

import Tags from './components/Tags';
import SocialsList from './components/SocialsList';

function Socials() {
  const page = useTypedSelector(selectSinglePost);

  if (!page) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <Main>
          <Tags />
          <SocialsList />
        </Main>
      </ContentContainer>
    </Component>
  );
}

export default Socials;

const Component = styled.section`
  padding: 30px 0;

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;

const Main = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.tablet(css`
    flex-direction: column;
  `)}
`;
